import { observer } from 'mobx-react';
import React from 'react';
import Input from '~/components/ui/Input';
import commonStyles from '~/screens/MailingScreen/components/MailingConstructor/TabConstructor/MailSettings/settingsElements/style.module.css';
import { MailingStore } from '~/screens/MailingScreen/stores/mailingStore';
import { getMaxLengthMessage } from '~/screens/MailingScreen/utils';
import useStores from '~/utils/useStores';
import styles from './style.module.css';

export const EmailTopic = observer(() => {
  const { mailingStore } = useStores() as {
    mailingStore: MailingStore;
  };

  const { mailingInstance } = mailingStore;
  const authorizationEmailObj = mailingInstance.get('authorizationEmail');
  const emailTopic = authorizationEmailObj.emailTopic;

  const setEmailTopic = (emailTopic: string) => {
    mailingInstance.update({
      authorizationEmail: { ...authorizationEmailObj, emailTopic },
    });
  };

  const maxTextLength = 55;
  const isErrorShown = emailTopic.length >= maxTextLength;

  return (
    <div className={styles.inputBlock}>
      <h3>Введите тему письма</h3>
      <Input
        placeholder="В вашей корзине остались товары"
        className={styles.input}
        value={emailTopic}
        onChangeValue={setEmailTopic}
        maxLength={maxTextLength}
        failure={isErrorShown}
      />
      {isErrorShown && (
        <div className={commonStyles.error}>
          {getMaxLengthMessage(maxTextLength)}
        </div>
      )}
    </div>
  );
});
